<div class="tw-rounded-3xl tw-bg-color-surface-card tw-shadow-elevation-card tw-overflow-hidden">
  <!-- Header / collapsed view. Not a native <button>: [header-action] below can project an
       interactive control (e.g. the coupons card's "Find More" button), and a <button> cannot
       validly contain another <button> — the browser silently breaks the nested control's
       hit-testing and keyboard activation, and it's dropped from the a11y tree. A div with
       role="button" keeps the same toggle affordance/keyboard behavior for this header while
       staying a legal ancestor for a projected interactive child. Only an expanded card may hide
       this header (min-xl): a collapsed one needs it to reopen. -->
  <div
    role="button"
    tabindex="0"
    [attr.aria-expanded]="isExpanded()"
    (click)="onHeaderClick($event)"
    (keydown.enter)="onHeaderKey($event)"
    (keydown.space)="onHeaderKey($event, true)"
    class="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-3 tw-px-4 tw-pt-4 tw-pb-2 tw-bg-color-surface-card tw-transition-colors tw-cursor-pointer"
    [class.min-xl:tw-hidden]="hideHeaderOnDesktop() && isExpanded()"
  >
    <div class="tw-flex tw-flex-col tw-items-start tw-gap-3 tw-w-full">
      <div class="tw-w-full tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-items-center">
          @if (headerIcon()) {
            <icon
              [size]="6"
              [name]="headerIcon()"
              class="tw-border-dt-border-tertiary tw-rounded-[9px] tw-p-[2px] tw-border-[4px]"
            ></icon>
          }
          <span
            class="tw-text-[16px] tw-font-semibold tw-tracking-[0.7px] tw-uppercase tw-text-color-text-secondary"
            [class.tw-ml-2]="headerIcon()"
          >
            {{ headerTitle() }}
          </span>
        </div>

        <!-- Chevron -->
        <div class="tw-flex tw-items-center tw-gap-2">
          <ng-content select="[header-action]"></ng-content>
        </div>

        @if (!hideChevron()) {
          <icon
            [size]="6"
            [name]="isExpanded() ? 'more-not-expanded' : 'more-expanded'"
            class="tw-hidden md:tw-flex"
          ></icon>
        }
      </div>

      <!-- Header subtitle from parent: unlike [collapsed-content], stays visible when expanded -->
      <ng-content select="[header-subtitle]"></ng-content>

      @if (!isExpanded()) {
        <!-- Collapsed description content from parent -->
        <ng-content select="[collapsed-content]"></ng-content>
      }

      @if (isExpanded() && showProgress()) {
        <!-- Progress section from parent (only if showProgress is true) -->
        <ng-content select="[progress-content]"></ng-content>
      }
    </div>
  </div>

  <!-- Expanded content -->
  <div *ngIf="isExpanded()" class="tw-bg-color-surface-card tw-px-2 tw-pb-5 tw-pt-4 sm:tw-px-3">
    <!-- Tabs and content from parent -->
    <ng-content select="[expanded-content]"></ng-content>
  </div>
</div>
